var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAwards = function SvgAwards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.696
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.818 8.089A2.783 2.783 0 0 1 2 5.479v-.696c0-.385.311-.696.696-.696H4.99m11.192 4.002A2.783 2.783 0 0 0 18 5.479v-.696a.695.695 0 0 0-.696-.696H15.01m-4.677-.148.715 1.54h1.392a.34.34 0 0 1 .24.594l-1.208 1.19.67 1.536a.365.365 0 0 1-.52.456l-1.616-.91-1.617.91a.365.365 0 0 1-.519-.456l.67-1.536-1.21-1.189a.34.34 0 0 1 .24-.596h1.391l.716-1.54a.368.368 0 0 1 .655 0h0zM10 12.435v3.13M5.826 18c0-1.345 1.869-2.435 4.174-2.435 2.305 0 4.174 1.09 4.174 2.435H5.826z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.591 8.282c-.312 3.125-4.06 5.471-7.136 3.322a5.083 5.083 0 0 1-2.08-3.682l-.557-5.54a.345.345 0 0 1 .089-.268A.345.345 0 0 1 5.166 2h9.67a.348.348 0 0 1 .347.383l-.592 5.899z"
  }))));
};
export default SvgAwards;